import { FC, ReactNode, useCallback, useMemo, useReducer, useRef } from "react";
import { createSubscriptionProcessSyncActions, createSubscriptionProcessAsyncActions } from "./actions";
import { SubscriptionProcessContext } from "./SubscriptionProcessContext";
import { initialState, subscriptionProcessReducer } from "./reducer";

const SubscriptionProcessProvider: FC<{ children: ReactNode }> = ({ children }) => {

  const [state, dispatch] = useReducer(subscriptionProcessReducer, initialState);

  const stateRef = useRef(state);
  stateRef.current = state;
  const getState = useCallback(() => stateRef.current, []);

  const syncActions = useMemo(() => createSubscriptionProcessSyncActions(dispatch), [dispatch]);
  const asyncActions = useMemo(() => createSubscriptionProcessAsyncActions(syncActions, getState), [syncActions, getState]);

  const value = useMemo(() => ({
    state,
    dispatch,
    ...syncActions,
    ...asyncActions
  }), [state, dispatch, syncActions, asyncActions]);

  return <SubscriptionProcessContext.Provider value={value}>
    {children}
  </SubscriptionProcessContext.Provider>
};

export default SubscriptionProcessProvider;
